import { HeaderLink, OfferCard, AcademyReview } from 'types';
import { ReactComponent as First } from 'assets/icons/alliance/1.svg';
import { ReactComponent as Second } from 'assets/icons/alliance/2.svg';
import { ReactComponent as Third } from 'assets/icons/alliance/3.svg';
import { ReactComponent as Fourth } from 'assets/icons/alliance/4.svg';
import { ReactComponent as Fifth } from 'assets/icons/alliance/5.svg';
import { ReactComponent as Sixth } from 'assets/icons/alliance/6.svg';

export const ALLIANCE_HEADER_LINKS: HeaderLink[] = [
    {
        isMail: true,
        path: 'academy.alliance@kaspersky.com',
    },
    {
        path: '/for-schools-and-colleges',
    },
    {
        path: '/course/cyberhygiene',
    },
    {
        path: '/course/enter-it',
    },
];

export const ALLIANCE_HEADER_LINKS_EN: HeaderLink[] = [
    {
        isMail: true,
        path: 'academy.alliance@kaspersky.com',
    },
    {
        path: '/for-businesses/',
    },
    {
        path: '/course/cyberhygiene',
    },
    {
        path: '/kids-cyber-resilience/',
    },
];

export const OFFER_CARDS_RU: OfferCard[] = [
    {
        front: 'Доступ к учебным материалам',
        icon: <First />,
        back: {
            items: [
                '<a href="/course/cybersecurity-entry-level" target="_blank" rel="noopener noreferrer">Введение в кибербезопасность</a>',
                '<a href="/course/normativnye-osnovy-informacionnoy-bezopasnosti" target="_blank" rel="noopener noreferrer">Нормативные основы информационной безопасности</a>',
                '<a href="/course/cybersecurity-fundamentals" target="_blank" rel="noopener noreferrer">Основы кибербезопасности</a>',
                '<a href="/course/cybersecurity-for-it-online" target="_blank" rel="noopener noreferrer">Онлайн-курс по кибербезопасности для ИТ-специалистов*</a>',
            ],
            title: 'Предоставляем доступ к нашим материалам и курсам:',
            disclaimer:
                '*курс предоставляется в рамках соглашения формата “Продвинутый”',
        },
        gradient:
            'linear-gradient(133.81deg, rgba(62, 220, 204, 1),rgba(69, 237, 169, 1))',
    },
    {
        front: 'Лекции и тренинги',
        icon: <Second />,
        back: {
            title: 'Организуем лекции с участием экспертов Kaspersky',
            description:
                'Для студентов как ИТ- и ИБ-специальностей, так и нетехнических направлений',
        },

        gradient:
            'linear-gradient(133.81deg, rgba(69, 223, 190, 1),rgba(69, 187, 248, 1))',
    },
    {
        front: 'Мероприятия для студентов',
        icon: <Third />,
        back: {
            items: [
                '<a href="https://www.kaspersky.ru/blog/kaspersky-club-introduction/37489/" target="_blank" rel="noopener noreferrer">Сообщество единомышленников Kaspersky Club</a>',
                '<a href="https://safeboard.kaspersky.ru/" target="_blank" rel="noopener noreferrer">Safeboard</a>',
                '<span>Участие Kaspersky в Днях Карьеры</span>',
            ],
            title: 'Открываем возможности для студентов:',
        },

        gradient:
            'linear-gradient(140.60deg, rgba(76, 179, 254, 1),rgba(151, 138, 249, 1))',
    },
    {
        front: 'Мероприятия для преподавателей',
        icon: <Fourth />,
        back: {
            items: [
                '<span>Экспертному сообществу Kaspersky Academy</span>',
                '<span>Практикумам для преподавателей от Kaspersky Academy</span>',
            ],
            title: 'Приглашаем преподавателей присоединиться к:',
        },
        gradient:
            'linear-gradient(133.81deg, rgba(69, 223, 190, 1),rgba(69, 187, 248, 1))',
    },
    {
        front: 'Доступ к технологиям Kaspersky ',
        icon: <Fifth />,
        back: {
            title: 'Предлагаем возможности для изучения реальных инструментов информационной безопасности и продуктов Kaspersky',
        },

        gradient:
            'linear-gradient(140.60deg, rgba(76, 179, 254, 1),rgba(151, 138, 249, 1))',
    },
    {
        front: 'Доступ к экспертизе мирового уровня',
        icon: <Sixth />,
        back: {
            title: 'Открываем возможности для взаимодействия с экспертами компании',
        },

        gradient:
            'linear-gradient(135.43deg, rgba(124, 153, 251, 1),rgba(157, 135, 249, 1))',
    },
];

export const OFFER_CARDS_EN: OfferCard[] = [
    {
        front: 'Access to educational content',
        icon: <First />,
        back: {
            items: [
                '<a href="/course/cybersecurity-entry-level" target="_blank" rel="noopener noreferrer">Cybersecurity. Entry Level</a>',
                '<a href="/course/cybersecurity-fundamentals" target="_blank" rel="noopener noreferrer">Cybersecurity. Fundamentals</a>',
                '<a href="/course/cybersecurity-for-it-online" target="_blank" rel="noopener noreferrer">Cybersecurity for IT Online</a>',
            ],
            title: 'Access to our courses:',
        },
        gradient:
            'linear-gradient(133.81deg, rgba(62, 220, 204, 1),rgba(69, 237, 169, 1))',
    },
    {
        front: 'Lectures and training sessions',
        icon: <Second />,
        back: {
            title: 'Lectures led by Kaspersky experts for students of both IT and cybersecurity programs, as well as non-technical majors',
        },

        gradient:
            'linear-gradient(133.81deg, rgba(69, 223, 190, 1),rgba(69, 187, 248, 1))',
    },
    {
        front: 'Events for students',
        icon: <Third />,
        back: {
            items: [
                '<span>Kaspersky Club</span>',
                '<span>Career Day Partcipation</span>',
            ],
            title: 'Opportunities for students:',
        },

        gradient:
            'linear-gradient(140.60deg, rgba(76, 179, 254, 1),rgba(151, 138, 249, 1))',
    },
    {
        front: 'Events for educators',
        icon: <Fourth />,
        back: {
            items: [
                '<span>Kaspersky Academy Expert Community</span>',
                '<span>Training Lab</span>',
            ],
            title: 'Invintation to Kaspersky Academy events:',
        },
        gradient:
            'linear-gradient(133.81deg, rgba(69, 223, 190, 1),rgba(69, 187, 248, 1))',
    },
    {
        front: 'Access to Kaspersky technologies',
        icon: <Fifth />,
        back: {
            title: 'Opportunities to explore Kaspersky cybersecurity tools and products',
        },

        gradient:
            'linear-gradient(140.60deg, rgba(76, 179, 254, 1),rgba(151, 138, 249, 1))',
    },
    {
        front: 'Access to world-class expertise',
        icon: <Sixth />,
        back: {
            title: 'Opportunities for engagement with company experts',
        },

        gradient:
            'linear-gradient(135.43deg, rgba(124, 153, 251, 1),rgba(157, 135, 249, 1))',
    },
];

export const UNIVERSITIES_RU: string[] = [
    'https://www.dvfu.ru/',
    'https://cu.ru/',
    'https://mephi.ru/',
    'https://bmstu.ru/',
    'https://www.hse.ru/',
    'https://www.mirea.ru/',
    'https://tuwaiq.edu.sa/',
    'https://www.metu.edu.tr/',
    'https://www.iitm.ac.in/',
    'https://www.senati.edu.pe/',
    'https://spbu.ru/',
    'https://mtuci.ru/',
    'https://mpei.ru/Pages/default.aspx',
    'https://kpfu.ru/',
    '',
];

export const UNIVERSITIES_EN: string[] = [
    'https://www.apu.edu.my/',
    'https://www.qu.edu.sa/en/',
    'https://tuwaiq.edu.sa/',
    'https://www.metu.edu.tr/',
    'https://www.iitm.ac.in/',
    'https://telkomuniversity.ac.id/en/',
    'https://www.senati.edu.pe/',
    'https://www.hse.ru/en/',
    'https://english.spbu.ru/',
    '',
];

export const ACADEMY_ALLIANCE_REVIEWS_RU: AcademyReview[] = [
    {
        title: 'Кто ты в ИТ',
        description:
            'Онлайн-курс, который поможет понять, какие профессии есть в ИТ и в информационной безопасности, и какие из них подходят именно тебе',
        image: '/assets/alliance/reviews/ru/1.jpg',
        link: 'https://academy.kaspersky.ru/course/enter-it',
    },
    {
        title: 'Кибергигиена',
        description:
            'На этом бесплатном онлайн-курсе вы узнаете, как защитить себя от киберугроз. Эксперты «Лаборатории Касперского» простым и понятным языком расскажут, как безопасно использовать интернет',
        image: '/assets/alliance/reviews/ru/2.jpg',
        link: 'https://academy.kaspersky.ru/course/cyberhygiene',
    },
    {
        title: 'Школам и <br />колледжам',
        description:
            'Методические материалы, учебные пособия для школьников и учителей, а также программа сотрудничества Kaspersky Academy Alliance для колледжей',
        image: '/assets/alliance/reviews/ru/3.jpg',
        link: 'https://academy.kaspersky.ru/for-schools-and-colleges/',
    },
    {
        title: 'Введение в <br />кибербезопасность',
        description:
            'Курс формирует представление о базовых концепциях, типах угроз, инструментах атакующих, направлениях профессиональной деятельности в ИБ и конструктивной информационной безопасности',
        image: '/assets/alliance/reviews/ru/4.jpg',
        link: 'https://academy.kaspersky.ru/course/cybersecurity-entry-level',
    },
    {
        title: 'Нормативные основы ИБ',
        description:
            'Курс предоставляет знания о системе нормативных актов, регулирующих информационную безопасность и деятельность ИБ-специалистов',
        image: '/assets/alliance/reviews/ru/5.jpg',
        link: 'https://academy.kaspersky.ru/course/normativnye-osnovy-informacionnoy-bezopasnosti',
    },
    {
        title: 'Основы <br />кибербезопасности',
        description:
            'Курс дает представление о ключевых практиках киберзащиты: от безопасности сетей и приложений до анализа вредоносного ПО и расследования киберинцидентов',
        image: '/assets/alliance/reviews/ru/6.jpg',
        link: 'https://academy.kaspersky.ru/course/cybersecurity-fundamentals',
    },
];

export const ACADEMY_ALLIANCE_REVIEWS_EN: AcademyReview[] = [
    {
        title: "Kids' Cyber Resilience",
        description:
            'A multistakeholder project aimed at fostering digital resilience in children and teenagers. Kaspersky and key stakeholders seek to educate children on how to stay safe online and make them resilient to threats they might encounter in the digital world',
        image: '/assets/alliance/reviews/ru/1_en.jpg',
        link: 'https://academy.kaspersky.com/kids-cyber-resilience/',
    },
    {
        title: 'Cyberhygiene',
        description:
            'This free online course will teach you how to protect yourself from cyber threats. In a simple and accessible way, Kaspersky experts will explain how to stay safe online and use your gadgets securely',
        image: '/assets/alliance/reviews/ru/2.jpg',
        link: 'https://academy.kaspersky.com/course/cyberhygiene',
    },
    {
        title: 'For Governments',
        description:
            'Trainings from Kaspersky Academy for government institutions. Integrate the Kaspersky best practices and expertise into your organization’s processes',
        image: '/assets/alliance/reviews/ru/3.jpg',
        link: 'https://academy.kaspersky.com/for-governments/',
    },
    {
        title: 'Cybersecurity.<br/>Entry Level',
        description:
            'The course provides solid foundation in cybersecurity, covering key concepts, common threats, types of attacks, career paths in cybersecurity, and ways to protect both personal and corporate environments',
        image: '/assets/alliance/reviews/ru/4.jpg',
        link: 'https://academy.kaspersky.com/course/cybersecurity-entry-level',
    },
    {
        title: 'Cybersecurity.<br/>Fundamentals',
        description:
            'The course provides an overview of key cybersecurity practices: from network and application security to malware analysis and incident investigation',
        image: '/assets/alliance/reviews/ru/5.jpg',
        link: 'https://academy.kaspersky.com/course/cybersecurity-fundamentals',
    },
];

export const SUPPORTED_LANGS = [
    { id: 'en', label: 'ENGLISH' },
    { id: 'id', label: 'BAHASA INDONESIA' },
    { id: 'vi', label: 'VIETNAMESE' },
];

export const VALID_LANG_IDS = SUPPORTED_LANGS.map((lang) => lang.id);
